import React, { useState, useCallback, useEffect } from 'react';
import { Editor } from '@nile/components';
import styled from 'styled-components';
import { Button, ButtonGroup, Heading } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import RichTextEditorPreview from './RichTextEditorPreview';

const RichTextEditorWrapper = styled.div`
  width: calc(100% - 5px);
  height: calc(100% - 30px);
  padding: ${(props) => (props.padded ? '0 6px' : '0')};

  .fr-box.fr-basic.fr-bottom {
    border: 1px solid #ececec;
    border-radius: 8px !important;
    padding: 8px 8px 10px 8px;
  }
`;

const RTEEditOption = styled.span`
  position: absolute;
  bottom: -10px;
  right: 18px;
  z-index: 999999;
`;

function RichTextEditor(props) {
  const {
    module = 'IT_DOC_RICH_TEXT',
    details = { operation: 'CREATE' },
    previewMode,
    saveChanges,
    handleChange,
    allowItDocumentRichTextEdit = true,
    isClientPortal,
    removeFullHeightOnEditor
  } = props;

  const [value, setValue] = useState(props.value || '');
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  const onContentChange = useCallback((newValue) => {
    setValue(newValue);

    if (handleChange) {
      props.handleChange(newValue);
    }
  }, []);

  const handleOnSave = () => {
    setEditMode(false);
    saveChanges(value);
  };
  const handleOnCancel = () => {
    setEditMode(false);
    setValue(props.value);
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const onPreviewMode = previewMode && !editMode;

  const getEditorClassNames = () => {
    return removeFullHeightOnEditor
      ? 'display-block'
      : 'display-block full-height';
  };

  return (
    <RichTextEditorWrapper
      padded={props.padded}
      className="position-relative visibilityContainer"
    >
      {props.label && (
        <div className="fx min-height-26">
          <Heading element="h3" weight="Bold">
            {props.label}
          </Heading>
          {previewMode && !editMode && allowItDocumentRichTextEdit && (
            <span
              onClick={() => toggleEditMode()}
              className="ml4 visibilityActions"
            >
              <SVGIcon name="Edit"></SVGIcon>
            </span>
          )}
        </div>
      )}
      <div
        className={
          onPreviewMode ? 'display-block full-height' : 'hiddenActions'
        }
      >
        <RichTextEditorPreview value={value?.content} />
      </div>
      <div className={onPreviewMode ? 'hiddenActions' : getEditorClassNames()}>
        <Editor
          placeholder={getTranslatedText(
            props.intl,
            'admin.policyManagement.alertPolicy.policies.enterValue.placeholder'
          )}
          module={module}
          details={details}
          template={value}
          updateTemplate={onContentChange}
          disabled={props.disabled}
          attachmentModule={module}
          disableAttachment={true}
          toolbarSticky={false}
        />
        {editMode && (
          <RTEEditOption>
            <ButtonGroup spacing="loose">
              <Button plainSecondary onClick={() => handleOnCancel()}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <Button primary onClick={() => handleOnSave()}>
                <FormattedMessage id="common.save" />
              </Button>
            </ButtonGroup>
          </RTEEditOption>
        )}
      </div>
    </RichTextEditorWrapper>
  );
}

export default injectIntl(RichTextEditor);
